import React, { useState, useContext, useEffect } from "react";
import { Modal, Col, Form, Row, Button } from "react-bootstrap";
// import { isMobile } from 'react-device-detect';
import ContextApp from "./../../../core/contexts/context.app";
import { useNavigate, useLocation } from "react-router-dom";
import ServiceStorage from "../../../core/services/service.storage";
import _ from "lodash";
import getCityDataAndSaveToStorage from "../GetCityListAndSaveToStorage"
function SelectCityModal({ showModalSelectCity, setShowModalSelectCity }) {
  let navigate = useNavigate();
  let location = useLocation();
  const screenWidth = window.innerWidth;
  const ctx = useContext(ContextApp);

  const handleClose = () => {
    setShowModalSelectCity(false);
  };
  const [regions, setRegions] = useState([]);

  useEffect(() => {
    (async () => {
      const {regoinResult,newUpdateDate} = await getCityDataAndSaveToStorage();
      ServiceStorage.setCity({ cityListLastUpdate: newUpdateDate, cityList: regoinResult, selectedCity: ctx.selectedCity })
      setRegions(regoinResult)
    })();
  }, []);

  const selectedCity = (item) => {
    ctx.setSelectedCity(item);
    ServiceStorage.setSelectedCity(item);
    setShowModalSelectCity(false);
    navigate("/c/" + item.englishName);
  };

  return (
    <>
      <Modal
        onHide={handleClose}
        show={showModalSelectCity}
        className={screenWidth < 575 && " modal-bottom "}
      >
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title id="contained-modal-title-vcenter">
            شهر مورد نظر خود را انتخاب نمایید
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-0 py-0 rounded-4 my-0 ">
          {regions.map((item, key) => {
            return (
              <div key={key}>
                <button
                  className="my-2  bg-white border-0 btn-no-style w-100 text-dark"
                  onClick={() => {
                    selectedCity(item);
                  }}
                >
                  {item.name}
                </button>
              </div>
            );
          })}
          <div className="my-2 text-center bg-white border-0 w-100 text-dark">
            به زودی...
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SelectCityModal;
